import * as angular from 'angular';

import {react2angular} from "react2angular";

import {Contractlist2} from '../components/contractlist2';

const ngModule = angular.module('reactContractlistModule', [])
    .component('reactContractlist', react2angular(Contractlist2, [], ['server', 'security', '$location', 'nvdbapi', '$q']));

const reactContractlistModuleName = ngModule.name;
export default reactContractlistModuleName;

